import { TableCell, TableRow } from "@mui/material";
import SharedTableContent from "./SharedTableContent";
import { formatDateToGMT, formatDollarsCurrency } from "../OptionsTrading/helpers";
import { StatusChip } from "./StatusChip";
import { isLimitOrder, isMultiLegOrder } from "./OrdersTable";
import { getPrimaryOrderForLimitOrders } from "./OpenPositions";

const OrderHistory = ({ navigateTab, findTradeByOrderId, historyOrders }) => {
  return (
    <>
      {historyOrders.map((order) => {
        const associatedTrade = findTradeByOrderId(order.external_order_id);

        return (
          <TableRow key={order.id} className="body2">
            <SharedTableContent order={order} hasLegs={isMultiLegOrder(order)} />
            <TableCell id="avgPrice">
              {order.avg_fill_price > 0
                ? formatDollarsCurrency(order.avg_fill_price)
                : formatDollarsCurrency(
                  Math.abs(
                    (associatedTrade?.preview_result?.orders[0].order_cost || 0)
                    / ((order.totalQuantity || 1) * 100),
                  ),
                )}
            </TableCell>
            <TableCell id="orderValue">
              {parseInt(order.avg_fill_price) > 0
                ? formatDollarsCurrency(order.last_fill_price * 100 * order.last_fill_quantity)
                : formatDollarsCurrency(associatedTrade?.preview_result?.cost)}
            </TableCell>
            <TableCell id="qty">

              {(() => {
                if (isMultiLegOrder(order)) {
                  return order.legs?.map((leg, index) => (
                    <TableRow key={`leg-${order.id}-${index}`}>
                      <TableCell className="nested-row">
                        {leg.exec_quantity + leg.remaining_quantity}
                      </TableCell>
                    </TableRow>
                  ));
                }

                if (isLimitOrder(order)) {
                  const openLeg = getPrimaryOrderForLimitOrders(order.legs);
                  return openLeg?.total_quantity || order.total_quantity;
                }

                return order.total_quantity;
              })()}
            </TableCell>

            {isMultiLegOrder(order)
              ? (
                  <TableCell>
                    {order.legs?.map((leg, index) => (
                      <TableRow key={`leg-${order.id}-${index}`}>
                        <TableCell className="nested-row">
                          <StatusChip status={order.status} handleStatusClick={navigateTab} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableCell>
                )
              : (
                  <TableCell><StatusChip status={order.status} handleStatusClick={navigateTab} /></TableCell>
                )}
            <TableCell>{formatDateToGMT(order.transaction_date)}</TableCell>

          </TableRow>
        );
      })}
    </>
  );
};

export default OrderHistory;
